import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertMessageService } from "@bundle/component/alert-message/alert-message.service";
import { AppMs13Service } from "app/business/service/app/app-ms13.service";
import moment from "moment";

@Component({
  selector: "app-confirm-send-ocs-dialog",
  templateUrl: "./confirm-send-ocs-dialog.component.html",
  styleUrls: ["./confirm-send-ocs-dialog.component.css"],
})
export class ConfirmSendOcsDialogComponent implements OnInit {
  formData: any = {};
  agreementCheck: boolean = false;

  constructor(
    private appMs13Service: AppMs13Service,
    private dialogRef: MatDialogRef<ConfirmSendOcsDialogComponent>,
    private alertMessageService: AlertMessageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.formData = data;
    console.log(this.formData);
  }

  ngOnInit() {
    this.formData.surveyOrderDate = this.surveyTimeSet(
      this.formData.surveyOrderTime,
    );
    this.formData.surveyAnalyzeOrderDate = this.analystTimeSet(
      this.formData.surveyAnalyzeOrderTime,
    );
    this.buildLegacySurveyorBFields();
  }

  // The dynamic surveyor (ประเภท ข.) list lives in formData.surveyorBList
  // (person 1 = หัวหน้า/chief, up to 30 people). The OCS Connect API request
  // (saveMs17SurveyorReport) keeps the same field shape as before
  // (surveyCheif/No, surveyBy2/No, surveyBy3/No, ...), so we flatten the
  // array back into those legacy field names here, extended up to person 30.
  private buildLegacySurveyorBFields() {
    (this.formData.surveyorBList || []).forEach((p, idx) => {
      const n = idx + 1; // 1-based person order
      if (n === 1) {
        this.formData.surveyCheif = p.name || "";
        this.formData.surveyCheifNo = p.empNo || "";
      } else {
        this.formData[`surveyBy${n}`] = p.name || "";
        this.formData[`surveyBy${n}No`] = p.empNo || "";
      }
    });
  }

  surveyTimeSet(e) {
    // Assume 'a' is your date object and 'b' is your time string
    let a = moment(this.formData.surveyOrderDate);
    let b = e;

    // Split the time string into hours and minutes
    let [hours, minutes] = b.split(":").map(Number);

    // Set the hours and minutes on the moment object
    a.hours(hours);
    a.minutes(minutes);

    return a;
  }

  analystTimeSet(e) {
    // Assume 'a' is your date object and 'b' is your time string
    let a = moment(this.formData.surveyAnalyzeOrderDate);
    let b = e;

    // Split the time string into hours and minutes
    let [hours, minutes] = b.split(":").map(Number);

    // Set the hours and minutes on the moment object
    a.hours(hours);
    a.minutes(minutes);

    return a;
  }

  sendOcs() {
    this.formData.isSendOCSConnect = "Y";
    this.formData.petitionDate = moment(this.formData.petitionDate)
      .utcOffset(7)
      .format("YYYY-MM-DDTHH:mm:ss");

    this.appMs13Service.saveMs17SurveyorReport(this.formData).then((res) => {
      if (res) {
        if (res.isSendOCSConnect == "N") {
          this.formData = { ...res };
          this.alertMessageService.open({
            message: "ไม่สามารถส่งข้อความได้ กรุณาลองใหม่อีกครั้ง",
            title: "",
          });
          return;
        } else {
          this.dialogRef.close(res);
        }
      }
    });
  }

  closeModal() {
    this.dialogRef.close(undefined);
  }
}
